import * as _ from 'lodash';

import { NextRegentsAdminDate } from '../../../../../../../ng2/shared/constants/next-regents-admin-date.constant';
import { WizardUtils } from './../../../../../../shared/services/wizard-utils/wizard-utils.service';

export class SchedulingCheckCtrl {
  static $inject = ['$scope', '$state', '$window', 'WizardUtils'];

  public nextRegentsAdminDate: string;
  public studentIdsNotPlannedForNeededExams: string[];
  public studentIdsNotScheduledInStars: string[];
  public studentIdsNotPlannedInPortal: string[];
  public studentsNotPlannedForNeededExamsOptions;
  public starsMismatchOptions;

  private filteredStudents;

  constructor(public $scope, private $state, private $window, private WizardUtils: WizardUtils) {}

  $onInit(): void {
    this.WizardUtils.startListeningAndLoad(this);
  }

  setUi(): void {
    this.nextRegentsAdminDate = NextRegentsAdminDate;
    this.filteredStudents = this.WizardUtils.getFilteredFlattenedStudents();
    this.studentIdsNotPlannedForNeededExams = this.getIdsForStudentsNotPlannedForNeededExams(this.filteredStudents);
    this.studentIdsNotScheduledInStars = this.getIdsForStudentsNotScheduledInStars(this.filteredStudents);
    this.studentIdsNotPlannedInPortal = this.getIdsForStudentsNotPlannedInPortal(this.filteredStudents);

    this.studentsNotPlannedForNeededExamsOptions = {
      columnKeys: ['cohort', 'regentsNeededForOnTrackDiploma', 'regentsNeededForOnTrackDiplomaNotSched'],
    };
    this.starsMismatchOptions = {
      columnKeys: [
        'cohort',
        'regentsSchedForNextAdmin',
        'examsSchedInPortalNotPlannedInStars',
        'examsSchedInStarsNotPlannedInPortal',
      ],
    };
  }

  /* istanbul ignore next */
  goToRegentsPlanningWizard(): void {
    const url = this.$state.href(`main.school.new-sdc.regents-planning.wizard`);
    this.$window.open(url, '_blank');
  }

  private getIdsForStudentsNotPlannedForNeededExams = (students: any) => {
    return _.reduce(
      students,
      (result, student: any) => {
        const { studentId, countOfRegentsNeededForOnTrackDiplomaNotSched } = student;
        const studentsHasUnaddressedRegentsNeeds = countOfRegentsNeededForOnTrackDiplomaNotSched > 0;
        if (studentsHasUnaddressedRegentsNeeds) result.push(studentId);
        return result;
      },
      [],
    );
  };

  private getIdsForStudentsNotScheduledInStars(students: any) {
    return _.reduce(
      students,
      (result, student: any) => {
        const { studentId, examsSchedInPortalNotPlannedInStars } = student;
        if (examsSchedInPortalNotPlannedInStars.length > 0) result.push(studentId);
        return result;
      },
      [],
    );
  }

  private getIdsForStudentsNotPlannedInPortal(students: any) {
    return _.reduce(
      students,
      (result, student: any) => {
        const { studentId, examsSchedInStarsNotPlannedInPortal } = student;
        if (examsSchedInStarsNotPlannedInPortal.length > 0) result.push(studentId);
        return result;
      },
      [],
    );
  }
}
